import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const StyleAnalyticCard = styled.div`
  border-radius: 12px;
  width: 100%;
  background-color: ${(props: any) => props.theme.colors.white};
  padding: 14px;
  box-shadow: ${(props: any) => props.theme.colors.boxShadow};
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: flex-start;
  @media (max-width: 768px) {
    width: 70%;
  }
`
export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
`

const sharedTextStyle = (props: any) => css`
  color: ${props.theme.colors.text};
  line-height: 20px;
  letter-spacing: 0.25px;
`

export const StyleAnalyticCardTitle = styled.p`
  ${sharedTextStyle}
  font-weight: 100;
  font-size: 14px;
`
export const StatsContainer = styled.div`
  display: flex;
  column-gap: 12px;
  align-items: center;
`
export const StatNumber = styled.p`
  ${sharedTextStyle}
  font-size: 18px;
`
export const StartPercentContainer = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  border-radius: 7.5px;
  padding: 2px 6px;
`
export const StatPercent = styled.p<{ up?: boolean }>`
  font-size: 12px;
  color: ${(props: any) =>
    props.up ? props.theme.colors.primary50 : props.theme.colors.red};
`
export const ActionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ActionButton = styled.button`
  background-color: transparent;
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  border-radius: 7px;
  color: ${(props: any) => props.theme.colors.text};
  line-height: 16px;
  letter-spacing: 0.25px;
  font-size: 12px;
  padding: 6px 7px;
  cursor: pointer;
`
export const ActionMessage = styled.p`
  color: ${(props: any) => props.theme.colors.text50};
  letter-spacing: 0.25px;
  line-height: 16px;
  font-size: 12px;
  width: 120px;
`

export const svgtranslate = `
    transform:translateY(2.5px)
`
